export var componentsLocales = {
  addButtonComment: 'Type comma or space',
  addButtonTitle: 'Add'
};